import { render, staticRenderFns } from "./WaitFor.vue?vue&type=template&id=2b13c0dc"
import script from "./WaitFor.vue?vue&type=script&lang=js"
export * from "./WaitFor.vue?vue&type=script&lang=js"
import style0 from "./WaitFor.vue?vue&type=style&index=0&id=2b13c0dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports